var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.117 18.426l-2.355-3.281-5.695 4.086-.025 7.035h4.04v-3.972c0-.61.294-1.183.79-1.54l3.245-2.328",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.117 18.426l-2.355-3.281-5.695 4.086-.025 7.035h4.04v-3.972c0-.61.294-1.183.79-1.54l3.245-2.328z",
    stroke: "#313340",
    strokeWidth: 0.594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.297 42.83a12.64 12.64 0 01-7.862 0l-.508-.168a2.056 2.056 0 01-1.365-2.416c.733-3.17.88-6.449.434-9.672l-.243-1.757a1.208 1.208 0 011.195-1.373h8.835c.733 0 1.297.647 1.196 1.373l-.317 2.288a23.814 23.814 0 00.387 8.618 2.643 2.643 0 01-1.752 3.106",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.297 42.83h0a12.64 12.64 0 01-7.862 0l-.508-.168a2.056 2.056 0 01-1.365-2.416c.733-3.17.88-6.449.434-9.672l-.243-1.757a1.208 1.208 0 011.195-1.373h8.835c.733 0 1.297.647 1.196 1.373l-.317 2.288a23.814 23.814 0 00.387 8.618 2.643 2.643 0 01-1.752 3.106z",
    stroke: "#313340",
    strokeWidth: 0.594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.015 27.444h-9.403v-2.487c0-.385.29-.708.674-.746 2.678-.27 5.377-.27 8.055 0a.75.75 0 01.674.746v2.487",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.015 27.444h-9.403v-2.487c0-.385.29-.708.674-.746 2.678-.27 5.377-.27 8.055 0a.75.75 0 01.674.746v2.487z",
    stroke: "#313340",
    strokeWidth: 0.594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.558 14.196L28.21 1l-1.627 12.141 4.738 7.49 11.67 3.73-6.432-10.165"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#313340",
    strokeWidth: 0.594,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.558 14.196L28.21 1l-1.627 12.141 4.738 7.49 11.67 3.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.676 34.92a3.363 3.363 0 11-6.726 0 3.363 3.363 0 016.726 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.676 34.92a3.363 3.363 0 11-6.726 0 3.363 3.363 0 016.726 0zm-10.995-7.387h15.055H17.68zm3.55-9.075l4.406-2.999-4.407 2.999zm1.416-2.722l-.24-.398a3.457 3.457 0 00-6.053 3.333 6.839 6.839 0 01-2.48 8.843L9 30.577l13.647-14.841z",
    stroke: "#313340",
    strokeWidth: 0.594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D3AEB2",
    strokeWidth: 0.7,
    fill: "#FFF",
    cx: 9.982,
    cy: 9.982,
    r: 9.632
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Prata-Regular, Prata",
    fontSize: 10,
    fill: "#88456E"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.82,
    y: 13.48
  }, "3")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.3f2f972ace36ddcf73a32b869b3dca40.svg";
export { ForwardRef as ReactComponent };